var image_viewer_default = {
  "fontElementMap": "_5Cowz",
  "imageContainer": "-Jv3q",
  "expandButton": "wwXRO",
  "expandIcon": "pRguY",
  "pointer": "o2n-a",
  "imageWrapper": "qgjoK",
  "imageRatio": "el5fm",
  "image": "Z5UAN",
  "imageOverlay": "zdJZA",
  "imagePreload": "zHhDw",
  "imageHighres": "U0pLu",
  "onlyHighRes": "gO82b",
  "image_loading": "air-A"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
